import Range from "./Range.js";

const Cooked = () => {
  return (
    <section className="cooked">
      <br />
      <label for="doneness">
        <strong>How do you want your patty cooked</strong>
      </label>
      <br />
      <br />
      <Range />
      <br />
    </section>
  );
};

export default Cooked;
